import { Inbox, Folder } from "lucide-react";

/**
 * MovePickerMenu — popover for moving selected catalog items into a
 * different folder (or back to Uncategorized).
 */
export default function MovePickerMenu({ folders, activeFolder, onPick, onClose }) {
  return (
    <>
      <div className="fixed inset-0 z-10" onClick={onClose} />
      <div
        className="absolute z-20 mt-9 left-0 sm:left-auto sm:right-0 w-56 rounded-lg border border-white/10 bg-[#0E0E0E] shadow-2xl p-1.5"
        data-testid="catalog-move-picker"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-[10px] uppercase tracking-[0.18em] text-white/45 px-2 pt-1 pb-1.5">Move into</div>
        <button
          onClick={() => onPick("__uncat__")}
          disabled={activeFolder === "__uncat__"}
          className="w-full text-left text-xs px-2 py-1.5 rounded hover:bg-white/[0.05] text-white/85 inline-flex items-center gap-2 disabled:opacity-30 disabled:cursor-not-allowed"
          data-testid="catalog-move-target-uncat"
        >
          <Inbox className="w-3.5 h-3.5 text-[#D4AF37]" /> Uncategorized
        </button>
        {folders.length === 0 ? (
          <div className="text-[11px] text-white/40 px-2 py-2">No folders to move into. Create one first.</div>
        ) : (
          folders.map((f) => (
            <button
              key={f.id}
              onClick={() => onPick(f.id)}
              disabled={activeFolder === f.id}
              className="w-full text-left text-xs px-2 py-1.5 rounded hover:bg-white/[0.05] text-white/85 inline-flex items-center gap-2 disabled:opacity-30 disabled:cursor-not-allowed"
              data-testid={`catalog-move-target-${f.id}`}
            >
              <Folder className="w-3.5 h-3.5 text-[#D4AF37]" /> {f.name}
            </button>
          ))
        )}
      </div>
    </>
  );
}
